<script setup lang="ts">
    import { sanitizeHtml } from '~/utils/sanitizeHtml';

    const props = defineProps<{ blok: AHeadlineComponentStoryblok }>();

    const component = computed(() => props.blok?.headlineLevel || 'h1');

    const headlineClasses = computed(() => {
        const customFontSize = `--font-size-${props.blok?.fontSize}`;
        const customFontStyle = `--font-family-${props.blok?.fontStyle}`;
        const customFontWeight = `--font-weight-${props.blok?.fontWeight}`;
        const customTextAlign = `--text-align-${props.blok?.textAlign}`;
        const customTextAlignDesktop = `--text-align-desktop-${props.blok?.textAlignDesktop}`;
        const customHyphenation = `--hyphenate-${props.blok?.hyphenation}`;

        const fontSize = props.blok?.fontSize ? customFontSize : '';
        const fontStyle = props.blok?.fontStyle ? customFontStyle : '';
        const fontWeight = props.blok?.fontStyle === 'figtree' ? customFontWeight : '';
        const textAlign = props.blok?.textAlign ? customTextAlign : '';
        const textAlignDesktop = props.blok?.textAlignDesktop ? customTextAlignDesktop : '';
        const hyphenation = props.blok?.hyphenation ? customHyphenation : '';
        const restrictWidth = props.blok?.restrictWidth ? '--restrict-width' : '';
        const eyeCandy = props.blok?.eyeCandy ? 'eye-candy' : '';

        return [
            fontSize,
            fontStyle,
            fontWeight,
            textAlign,
            textAlignDesktop,
            hyphenation,
            restrictWidth,
            eyeCandy
        ].filter(Boolean); // Removes any empty strings
    });

    const convertedHeadline = computed(() => {
        return props.blok?.headline.replaceAll('{s}', '<sup>').replaceAll('{e}', '</sup>');
    });
</script>
<template>
    <component
        :is="component"
        v-editable="props.blok"
        class="headline"
        :class="headlineClasses"
    >
        <span>
            <!-- eslint-disable vue/no-v-html -->
            <span
                class="headline-text"
                v-html="sanitizeHtml(convertedHeadline)"
            ></span>
            <!-- eslint-enable vue/no-v-html -->
        </span>
    </component>
</template>
<style lang="scss" scoped>
    @import '~/assets/scss/headline/headline.scss';
</style>
